<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage">
        <div class="ibox-content" style="overflow: scroll;" [ngClass]="{'calendar-view' : maintenanceCalendarService.view == 'calendar'}">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Amenities'" [buildings]="maintenanceCalendarService.buildingsForRead"></filter>
                </div>

                <maintenance-calendar-filter (onAmenitiesChange)="onAmenitiesChange($event)"></maintenance-calendar-filter>
                <div *ngIf="maintenanceCalendarService.canEdit() && (!authenticationService.userIsResident || (authenticationService.userIsResident && maintenanceCalendarService.amenitiesByBuilding.length > 0))"
                     class="col-sm-3">
                    <button type="button" class="btn btn-w-m btn-primary pull-right"
                            (click)="maintenanceCalendarService.isAmenityModalShow = true"
                            [disabled]="!(maintenanceCalendarService.buildings.length || residentService.buildings.length)">
                        <i class="fa fa-plus-circle"></i> New Booking
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view [itemData]="amenitiesData"></filters-view>
                </div>
            </div>
            <div class="row m-sm isDesktop" style="width: 220px; display: inline-flex; float: right;">
                <div class="col-sm-6" (click)="maintenanceCalendarService.view = 'list'"
                     [ngClass]="{'mtv-primary-color' : maintenanceCalendarService.view == 'list'}" style="cursor: pointer;">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                    List View
                </div>
                <div (click)="maintenanceCalendarService.view = 'calendar'"
                     [ngClass]="{'mtv-primary-color' : maintenanceCalendarService.view == 'calendar'}"  style="cursor: pointer;">
                    <i class="fa fa-calendar-o" aria-hidden="true"></i>
                    Calendar View
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allAmenities'" [ngClass]="{'sk-loading': maintenanceCalendarService.spinnerShow}">
                    <maintenance-calendar-list *ngIf="maintenanceCalendarService.view == 'list'"></maintenance-calendar-list>
                    <maintenance-calendar-calendar-view *ngIf="maintenanceCalendarService.view == 'calendar'"></maintenance-calendar-calendar-view>
                </tab-item>
                <pagination *ngIf="maintenanceCalendarService.data.allAmenities.total && urlService.queryParams['page']"
                            [total]="maintenanceCalendarService.data['allAmenities'].total"></pagination>
                <spinner [spinnerShow]="maintenanceCalendarService.spinnerShow && maintenanceCalendarService.view == 'list'"></spinner>
                <spinner [spinnerShow]="maintenanceCalendarService.calendarSpinnerShow && maintenanceCalendarService.view == 'calendar'"></spinner>
            </tabs-wrapper>
        </div>
    </div>
</div>

<maintenance-calendar-modal *ngIf="maintenanceCalendarService.isAmenityModalShow"></maintenance-calendar-modal>
<maintenance-calendar-view *ngIf="maintenanceCalendarService.isAmenityViewShow"></maintenance-calendar-view>



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar.component.html